export const useResponsiveThumbnail = () => {
  const { normalizeThumbnail } = useCasino();

  // Variante única 320x373 (proporção 6:7, igual ao card — evita corte duplo)
  // em todos os lugares e viewports. fit=cover recorta no tamanho do card e
  // format=auto entrega AVIF/WebP. Os cards de jogo são pequenos (~87–136px),
  // então 320w cobre 2–3x mesmo em telas retina. quality=70 dá nitidez sem
  // pesar muito — é o piso de qualidade que queremos em qualquer device.
  function getResponsiveThumbnailSrc(thumbnail: string): string {
    const base = normalizeThumbnail(thumbnail);

    if (!base) {
      return '';
    }

    return `${base}/width=320,height=373,fit=cover,quality=70,format=auto`;
  }

  return {
    getResponsiveThumbnailSrc,
  };
};
